import {UnreachableError} from '../../../libs/shared/core/src/helpers/types/customErrors';
import {AnnotationAiSuggestionModel} from '../../models/api/annotationModel';
import {AnnotationAnnotatedResourcesEnum, AnnotationTypesEnum} from '../../models/api/annotationTypes';
import {
  ConversationAiMarkModel,
  ConversationAiResourcesEnum,
  ConversationAiStatusesEnum,
} from '../../models/api/conversationAiMarkModel';
import {ConversationModel} from '../../models/api/conversationModel';

export interface AiReview {
  status: ConversationAiStatusesEnum.APPROVED | ConversationAiStatusesEnum.DISCARDED;
  resourceId: number | undefined;
}

export function computeAiReviewStatus(
  conversation: ConversationModel | undefined,
  resourceId: number | undefined,
  aiSuggestion: AnnotationAiSuggestionModel,
) {
  const aiMark = findRelatedAiMark(conversation, resourceId, aiSuggestion);
  return aiMark?.status;
}

export function findRelatedAiMark(
  conversation: ConversationModel | undefined,
  resourceId: number | undefined,
  aiSuggestion: AnnotationAiSuggestionModel,
): ConversationAiMarkModel | undefined {
  if (!conversation?.aiMarks) {
    return undefined;
  }

  const {aiMarks} = conversation;

  const {type, annotatedResourceId, annotatedResourceType} = aiSuggestion;

  switch (type) {
    case AnnotationTypesEnum.AI_TAG_SUGGESTION: {
      return aiMarks.find(
        (mark) =>
          mark.resourceType === ConversationAiResourcesEnum.TAG &&
          annotatedResourceId === mark.messageId &&
          annotatedResourceType === AnnotationAnnotatedResourcesEnum.MESSAGE &&
          aiSuggestion.tagIds.includes(mark.resourceId),
      );
    }

    case AnnotationTypesEnum.AI_KNOWLEDGE_BASE_ARTICLES_SUGGESTION: {
      return aiMarks.find(
        (mark) =>
          mark.resourceType === ConversationAiResourcesEnum.KNOWLEDGE_BASE_ARTICLE &&
          annotatedResourceId === mark.messageId &&
          annotatedResourceType === AnnotationAnnotatedResourcesEnum.MESSAGE &&
          mark.resourceId === resourceId,
      );
    }

    default:
      throw new UnreachableError(type);
  }
}

export function filterAiMarkForConversation(
  conversation: ConversationModel,
  resourceType: ConversationAiResourcesEnum,
  status: ConversationAiStatusesEnum,
): ReadonlyArray<ConversationAiMarkModel> {
  return conversation.aiMarks?.filter((m) => m.resourceType === resourceType && m.status === status) ?? [];
}
